
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yufldbpdnvhgprflkmsy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl1ZmxkYnBkbnZoZ3ByZmxrbXN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcxOTI2OTcsImV4cCI6MjA1Mjc2ODY5N30.XDjbGoOBo6j_IgKk7MW2tDuWPAlL33kes514Z3nt4vc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
  }
});
